import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';
import { FIRMA } from '../data/firma';

/*
 * Strona 404.
 *
 * Wczesniej build/404.html byl KOPIA prerenderowanej strony glownej, wiec kazdy
 * nieistniejacy adres zwracal tresc strony glownej, jej tytul i jej canonical.
 * Google widzial wtedy dziesiatki adresow z identyczna trescia wskazujaca na
 * "/" - stad raport "Duplikat, brak kanonicznego wybranego przez uzytkownika"
 * dla adresow wpisow blogowych zapytanych w korzeniu domeny.
 *
 * Dlatego tutaj: wlasny tytul, noindex i BRAK canonicala (ten sam dokument
 * odpowiada pod dowolnym adresem, wiec nie ma adresu, ktory moglby byc jego
 * wersja kanoniczna).
 */
export default function NotFound() {
  return (
    <>
      <SEO
        title="Nie znaleziono strony - Sensorini Olsztyn"
        description="Strona o podanym adresie nie istnieje. Sprawdź, czym zajmuje się gabinet Sensorini w Olsztynie."
        type="website"
        noindex
        canonical={false}
      />
      <div className="article-container">
        <h1>Nie znaleziono strony</h1>

        <div className="section">
          <p>
            Strona o tym adresie nie istnieje albo została przeniesiona. Poniżej
            znajdziesz to, czego najczęściej szukają rodzice.
          </p>

          <ul>
            <li>
              <Link to="/diagnoza-sensoryczna-olsztyn/">Diagnoza integracji sensorycznej w Olsztynie</Link>
            </li>
            <li>
              <Link to="/terapia-integracji-sensorycznej-olsztyn/">Terapia integracji sensorycznej</Link>
            </li>
            <li>
              <Link to="/kiedy-do-terapeuty/">Kiedy zgłosić się do terapeuty SI</Link>
            </li>
            <li>
              <Link to="/cennik/">Cennik</Link>
            </li>
            <li>
              <Link to="/kontakt/">Kontakt i dojazd</Link>
            </li>
            <li>
              {/* Blog to osobna aplikacja (WordPress), wiec zwykly <a>, nie <Link>. */}
              <a href="/integracja-sensoryczna/">Artykuły o integracji sensorycznej</a>
            </li>
          </ul>

          <p>
            Jeśli szukasz konkretnego artykułu, zajrzyj do{' '}
            <a href="/integracja-sensoryczna/">poradnika</a> albo zadzwoń:{' '}
            <a href={`tel:${FIRMA.telefonE164}`}>{FIRMA.telefon}</a>.
          </p>
        </div>
      </div>
    </>
  );
}
